import $http from "../axios";

const state = {
  lockers: [],
  lockerBeingManaged: {}
};

const getters = {
  lockers: state => {
    return state.lockers;
  },
  lockerBeingManaged: state => {
    return state.lockerBeingManaged;
  }
};

const actions = {
  getLockers({ commit }) {
    return new Promise((resolve, reject) => {
      $http
        .get(`lockers`)
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_LOCKERS", res.data.payload.lockers);
            commit(
              "SET_ALL_LOCKER_DELIVERIES_QTY",
              res.data.payload.allLockerDeliveriesQty
            );
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  setLockerBeingManaged({ commit }, locker) {
    commit("SET_LOCKER_BEING_MANAGED", locker);
  }
};

const mutations = {
  SET_LOCKERS(state, lockers) {
    state.lockers = lockers;
  },

  SET_LOCKER_BEING_MANAGED(state, locker) {
    state.lockerBeingManaged = locker;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
